var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.hasSlot)?_c('span',{class:_vm.slotClasses},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/divider/divider.vue